import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#434190",
        secondary: "#7F9CF5",
        accent: "#8c9eff",
        error: "#E53E3E",
        background: "#f6f3e5"
      }
    }
  }
});
